import { Text, usePreventWindowScroll } from '@simplywallst/ui-core';
import { RichTextEditor } from '@/components/RichTextEditor';
import ActionSheet, {
  Background,
  Header,
  Panel,
  Sheet,
} from '@components/ActionSheet';
import { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import { AnnouncementModalEditorToolbar } from './components/AnnouncementModalEditorToolbar';

type Props = {
  announcement?: NonNullable<Narrative['announcements']>[number];
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (content: string) => void;
  ctaText?: string;
};

export const AnnouncementModal = ({
  announcement,
  isOpen,
  onClose,
  onSubmit,
  ctaText = 'Publish',
}: Props) => {
  const PreventWindowScroll = () => {
    usePreventWindowScroll();
    return null;
  };

  return (
    <ActionSheet open={isOpen} onClose={onClose}>
      <Background onClick={onClose} />
      {isOpen && <PreventWindowScroll />}
      <Sheet>
        <div
          data-cy-id="narrative-announcement-modal"
          className="grid grid-rows-[calc(40px+env(safe-area-inset-top))_1fr] overflow-hidden"
        >
          <Panel
            templateRows="max-content 1fr"
            row="2"
            className="overflow-hidden"
          >
            <Header>
              <Text
                typography="baseStrong"
                color="white"
                data-cy-id="narrative-announcement-modal-heading"
              >
                Share Announcement
              </Text>
            </Header>

            <div className="grid grid-rows-1 overflow-hidden px-x3 pb-x1">
              <RichTextEditor
                enableImages
                defaultContent={announcement?.contentHtml}
                className="overflow-hidden"
              >
                <AnnouncementModalEditorToolbar
                  onSubmit={onSubmit}
                  submitText={ctaText}
                />
              </RichTextEditor>
            </div>
          </Panel>
        </div>
      </Sheet>
    </ActionSheet>
  );
};
